import { RootState } from '@reducers';

export const selectPersonalAccidentPolicyDetails = (state: RootState) => state.userDashboardRouteReducer.policyDetailsReducer.personalAccidentPolicyDetailsReducer;
